module.exports = __webpack_public_path__ + "static/media/ROPEZE_BANNER_2.0b8947a4.jpg";